<template>
  <layout-empty>
    <div class="call_script--container">
      <section class="is-medium text-center pb-100">
        <h1 class="title">{{ title }}</h1>
        <h2>{{ description }}</h2>
      </section>

      <section class="content is-normal mb-200" v-if="isCallScriptActive">
        <ol type="1">
          <li
            class="mb-150"
            v-for="(step, stepIndex) in callScript.steps"
            :key="stepIndex"
          >
            <span v-html="step.statement"></span>

            <call-script-public-step-fields
              :field-data="fieldData[step.id]"
              :step-id="step.id"
              :validation-errors="validationErrors"
              :rei-real-estate-property-options-open="reiRealEstatePropertyOptionsOpen"
              :rei-real-estate-contact-options-open="reiRealEstateContactOptionsOpen"
              v-if="fieldData[step.id]"
            ></call-script-public-step-fields>
          </li>
        </ol>

        <div class="field is-grouped mb-0 pr-100" v-if="totalFields">
          <div class="control">
            <button-default @click="submit" :loading="isSaving">
              Submit
            </button-default>
          </div>
        </div>

        <p v-show="isSaving" class="text-sub-label mt-50">The page will reload after submission</p>
      </section>
    </div>
  </layout-empty>
</template>

<script>
import {MODELS} from "../../services/models";
import {ENUMS} from "../../services/enums";
import CallScriptPublicStepFields from "./components/CallScriptPublicStepFields";

export default {
  name: "CallScriptPublicPage",
  components: {
    CallScriptPublicStepFields,
  },
  data() {
    return {
      reiRealEstatePropertyOptionsOpen: false,
      reiRealEstateContactOptionsOpen: false,
      callScript: {},
      campaigns: {},
      contactTags: {},
      fieldData: {},
      validationErrors: {},
      form: {
        call_script_id: null,
        call_script_identifier: null,
        steps: {}
      },
      propertyAddressFields: [
        {
          id: 'line_1',
          inputId: 'property-streetaddress',
          label: 'Street Address',
          value: '',
          type: MODELS.Property.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Property - Street Address'
        },
        {
          id: 'city',
          inputId: 'property-city',
          label: 'City',
          value: '',
          type: MODELS.Property.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Property - City'
        },
        {
          id: 'state',
          inputId: 'property-state',
          label: 'State',
          value: '',
          type: MODELS.Property.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Property - State'
        },
        {
          id: 'postcode',
          inputId: 'property-postcode',
          label: 'Postcode',
          value: '',
          type: MODELS.Property.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Property - Postcode'
        },
      ],
      contactAddressFields: [
        {
          id: 'street',
          inputId: 'contact-streetaddress',
          label: 'Street Address',
          value: '',
          type: MODELS.Contact.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Contact - Street Address'
        },
        {
          id: 'line_2',
          inputId: 'contact-line2',
          label: 'Apt, Suite, Units, etc.',
          value: '',
          type: MODELS.Contact.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Contact - Apt, Suite, Units, etc.'
        },
        {
          id: 'city',
          inputId: 'contact-city',
          label: 'City',
          value: '',
          type: MODELS.Contact.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Contact - City'
        },
        {
          id: 'state',
          inputId: 'contact-state',
          label: 'State',
          value: '',
          type: MODELS.Contact.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Contact - State'
        },
        {
          id: 'postcode',
          inputId: 'contact-postcode',
          label: 'Postcode',
          value: '',
          type: MODELS.Contact.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Contact - Postcode'
        },
      ],
      totalFields: 0,
      isSaving: false
    }
  },
  mounted() {
    // document.getElementById('global-event-listener-div').addEventListener("click", (event) => {
    //   this.reiRealEstatePropertyOptionsOpen = event.target.className.includes("dont-close-property-search-results");
    //   this.reiRealEstateContactOptionsOpen = event.target.className.includes("dont-close-contact-search-results");
    // }, true);
  },
  created() {
    this.$api.callScripts.getByIdentifier(this.$route.params.identifier)
      .then(res => {
        this.callScript = res.data.callscript;
        this.campaigns = res.data.campaigns;
        this.contactTags = res.data.contact_tags;

        if(this.callScript) {
          this.initFormData()
        }
      });
  },
  computed: {
    title() {
      if(this.isCallScriptActive) {
        return this.callScript.name;
      } else {
        return 'Call Script Not Found'
      }
    },
    description() {
      if(this.isCallScriptActive) {
        return this.callScript.description;
      } else {
        return 'The call script you are looking for is no longer available.'
      }
    },
    isCallScriptActive() {
      return this.callScript && this.callScript.length !== 0;
    }
  },
  methods: {
    initFormData() {
      const parameters = this.$route.query;

      this.callScript.steps.map((step) => {
        if (step.fields.length !== 0) {
          this.fieldData[step.id] = step.fields.map((field) => {
            /**
             * Override Full Address to collection of address fields
             * Street Address, City, State, and Postcode
             * line_2 is optional
             */
            if (field.id === 'full_address') {
              let data = (field.type === MODELS.Property.class_name) ? this.propertyAddressFields : this.contactAddressFields;

              return data.map(row => {
                // match parameters if we have to pre-populate field
                row.value = (parameters[row.inputId]) ? parameters[row.inputId] : '';
                row.isRequired = (field.required) ? Number(field.required) : 0;

                // force contact - line_2 into optional field
                if (row.type === MODELS.Contact.class_name && row.id === 'line_2') {
                  row.isRequired = 0;
                }

                return row;
              });
            }

            let inputId = field.displayLabel.toLowerCase().replace(/\s/gm, '');
            let data = {
              id: field.id,
              inputId: inputId,
              label: field.label,
              value: (parameters[inputId]) ? parameters[inputId] : '', // match parameters if we have to pre-populate field
              type: field.type,
              fieldType: (field.fieldType) ? field.fieldType : ENUMS.CustomFieldTypeEnum.Text.value,
              placeholder: field.displayLabel,
              isRequired: (field.required) ? Number(field.required) : 0,
              customFieldableType: null,
            }

            if (field.type === MODELS.Record.class_name && field.id === 'campaign_id') {
              data.value = (parameters[inputId]) ? parameters[inputId] : null;
              data.options = this.campaigns;
            }

            if (field.type === MODELS.Contact.class_name && field.id === 'contact_tag_id') {
              data.value = (parameters[inputId]) ? parameters[inputId] : [];
              data.options = this.contactTags;
            }

            if (field.custom_field) {
              let optionFound = field.custom_field.options.find(option => option === data.value);

              if (field.custom_field.options.length === 0) {
                data.value = (data.value) ? data.value : field.custom_field.default_value;
              }
              // field is a dropdown and parameter value is not in the option list
              else if (field.custom_field.options.length !== 0 && optionFound === undefined) {
                data.value = field.custom_field.default_value;
              }
              // field is a dropdown and parameter value is in the option list
              else if (field.custom_field.options.length !== 0 && optionFound !== undefined) {
                data.value = optionFound;
              }

              data.label = field.custom_field.label;
              data.options = field.custom_field.options;
              data.fieldType = field.custom_field.type;
              data.customFieldableType = field.custom_field.custom_fieldable_type;
            }

            return data;
          });

          this.fieldData[step.id] = this.fieldData[step.id].flat();
          this.totalFields += this.fieldData[step.id].length;
        }
      });

      this.form.call_script_id = this.callScript.id;
      this.form.call_script_identifier = this.callScript.identifier;
    },
    submit() {
      // reset to avoid duplicate
      this.form.steps = {};
      let emptyCount = 0;

      this.callScript.steps.map((step) => {
        if (this.fieldData[step.id]) {
          let mapFields = this.fieldData[step.id].map((field) => {
            return {
              id: field.id,
              value: field.value,
              type: field.type,
              custom_fieldable_type: field.customFieldableType,
              is_requrired: field.isRequired
            };
          });

          this.form.steps[step.id] = { fields: mapFields };

          emptyCount += mapFields.filter(field => field.value === '' || field.value === null).length;
        }
      });

      if (emptyCount !== this.totalFields) {
        this.submitScript();
        return;
      }

      this.$buefy.snackbar.open({
        message: 'Submitting empty form is not allowed.',
        type: 'is-info',
        position: 'is-bottom',
        indefinite: true
      });
    },
    submitScript() {
      this.isSaving = true;
      this.validationErrors = {};

      this.$api.callScripts.submit(this.form)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Data has been saved, please wait until the page reloads',
            type: 'is-success',
            duration: 5000
          });
          setTimeout(function(){ window.location.reload(); }, 1500);
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.validationErrors = error.response.data.errors
            this.$buefy.snackbar.open({
              message: 'Your missing out something, double check all the fields.',
              type: 'is-danger',
              position: 'is-bottom',
              indefinite: true
            });

          } else {
            this.$buefy.snackbar.open({
              message: 'Server Error. Something went wrong.',
              type: 'is-danger',
              position: 'is-bottom',
              indefinite: true
            });
          }

          this.isSaving = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.call_script--container {
  max-width: 800px;
  margin: 0 auto;
}

.content {
  padding: $pagePaddingVertical;
  background-color: $white;
  line-height: 1.2;
}

.field.is-grouped {
  justify-content: flex-end;
}

.text-sub-label {
  text-align: right;
}
</style>
